import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowFitBottomRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.31 2.501a.5.5 0 0 0-.5-.5H2.002V7.81h.5-.5a.5.5 0 1 0 1 0h-.5.5V3.708l9.291 9.29H5.535a.5.5 0 0 0 0 1h6.964a1.5 1.5 0 0 0 1.5-1.5V5.535a.5.5 0 1 0-1 0v6.758L3.708 3H7.81a.5.5 0 0 0 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomRight16);
